import { Heading, Text, Container, Flex, Button, Stack, Spinner } from '@chakra-ui/react'
import ChildDetailCard from './ChildDetailCard'
import { Link as RouterLink } from 'react-router-dom'
import { FiPlusCircle } from 'react-icons/fi'
import { useMyProfileAsParent } from '@/modules/parent/hooks/useMyProfileAsParent'

function DashboardChildrenSection() {
    const { data: parentData, loading: parentDataLoading } = useMyProfileAsParent()

    const listChildren = () => {
        return parentData.children.length > 0 ? (
            parentData.children.map((child, index: number) => {
                return (
                    <ChildDetailCard
                        key={child._id}
                        name={`${child.firstName} ${child.middleName} ${child.lastName}`}
                        isCheckedIn={child.isCheckedIn}
                        picture={child.picture}
                        lastCheckinCode={child.lastCheckinCode}
                        label={`Child ${index + 1}`}
                    />
                )
            })
        ) : (
            <Text>
                No child added yet &nbsp;
                <Button
                    rightIcon={<FiPlusCircle />}
                    as={RouterLink}
                    p={2}
                    size="sm"
                    variant="outline"
                    to="/user/parent/children-list"
                >
                    Add Children Here
                </Button>
            </Text>
        )
    }

    if (parentDataLoading) {
        return (
            <Stack padding={6}>
                <Spinner />
            </Stack>
        )
    }

    return (
        <Container maxW={'full'} my={12}>
            <Heading py="4" color={'gray.600'} fontSize="md">
                List of Children
            </Heading>
            <Flex flexWrap="wrap" gridGap={6} justify="left">
                {listChildren()}
            </Flex>
        </Container>
    )
}

export default DashboardChildrenSection
